import i18n from '@/utils/i18n';
import React from 'react';
import { CHECK_IN_ROUTES } from '@/navigators/routes';
import { CheckInStackParams } from '@/navigators/types';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { KeyboardAwareScrollView } from '@/components/with-keyboard-aware';
import { ModalContainer } from '@/components/modal-container';
import { OrderCheckInSingleItemScreen } from './order-check-in/order-check-in-single-item-screen';
import { StackScreenProps } from '@react-navigation/stack';
import { Text, TouchableOpacity } from 'react-native';

export type Props = StackScreenProps<
  CheckInStackParams,
  CHECK_IN_ROUTES.CheckInSingleItem
>;

export const CheckInSingleItemScreen: React.FC<Props> = ({
  navigation,
  route,
}) => {
  const {
    params: { checkInItem, onDonePress },
  } = route;

  const [styles] = useStyles();
  return (
    <ModalContainer
      navigationHeaderProps={{
        actions: [
          {
            component: (
              <TouchableOpacity
                onPress={() => {
                  navigation.goBack();
                  onDonePress();
                }}
              >
                <Text style={[TYPOGRAPHY.medium, styles.doneButton]}>
                  {i18n.t('done')}
                </Text>
              </TouchableOpacity>
            ),
          },
        ],
        showBackButton: false,
      }}
      showLargeLayoutCloseButton={false}
    >
      <KeyboardAwareScrollView
        contentContainerStyle={styles.contentContainer}
        extraSpacing={40} // Account for extra vertical spacing of stylized TextArea
        keyboardDismissMode="on-drag"
      >
        <OrderCheckInSingleItemScreen checkInItem={checkInItem} />
      </KeyboardAwareScrollView>
    </ModalContainer>
  );
};

const useStyles = createStyles(() => ({
  contentContainer: {
    flexGrow: 1,
  },
  doneButton: {
    ...FONTS.primarySemiBold,
  },
}));
